<template>
  <div class="main">
    <div class="head">
      <div class="title">{{ site_title }}</div>
    </div>
    <div class="body">
      <div class="left">
        <left />
      </div>
      <div class="middle">
        <div class="top">
          <middle-top />
        </div>
        <div class="bottom">
          <div class="box-title">
            <div>救生员上岗状态</div>
            <div class="btn-area">
              <router-link :to="`/lifeguard?pool_id=`+mapData.id" class="btn">救生员概览 ></router-link>
              <router-link :to="`/position?pool_id=`+mapData.id" class="btn">岗位概览 ></router-link>
            </div>
          </div>
          <middle-bottom />
        </div>
      </div>
      <div class="right">
        <right />
      </div>
    </div>
  </div>
</template>

<script>
import Right from './right'
import MiddleTop from './middleTop'
import MiddleBottom from './middleBottom'
import Left from './left'

import storage from 'store'
import { USER_INFO,SID } from '@store/mutation-types.js'

export default {
  components: { MiddleTop, Right, Left, MiddleBottom },
  mounted() {
    this.site_title = storage.get(USER_INFO).config.site_title

    window.document.title = this.site_title
		this.$http({
		  url: `bkapi/stadium/pools`,
		  // baseURL: '/bkapi',
		  // method: 'get',
		  params: {
		    sid: storage.get(USER_INFO).sid,
		  },
		}).then((r) => {
			// console.log('---1', r)
			this.mapData = r[0]
		  // this.pool_list = r.data.list
		})
  },
  data() {
    return {
      site_title: '救生管理2.0大屏',
			mapData: {},
    }
  },
  methods: {},
}
</script>

<style lang="less" scoped>
.main {
  .warn-dialog {
    position: absolute;
    top: -10%;
    left: -3%;
    width: 240px;
    z-index: 99;
    background: url(../../assets/dongti/warn-bg.png) no-repeat center center/100% 100%;
    padding: 15px;
    .title {
      position: relative;
    }
    .icon {
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 80%;
      }
    }
    .name {
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      margin: 12px 0;
    }
    .btn-area {
      margin-top: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.stadium {
  position: fixed;
  left: 26%;
  top: 100px;
  width: 20%;
  height: auto;
  background: #046d93;
  border: 1px solid #7ad9ff;
  padding: 20px 15px;
  color: #03bce2;
  z-index: 999;
  .name {
    font-size: 18px;
    margin-bottom: 12px;
    width: 100%;
    position: relative;
    .sname {
      display: block;
    }
    .icon {
      position: absolute;
      top: -12px;
      right: 0px;
      font-size: 20px;
    }
  }
  .citem {
    font-size: 14px;
    padding: 6px 0;
  }
  .btn-area {
    margin-top: 12px;
  }
}
.main {
  min-height: 100vh;
  background: #002146;
  // overflow: hidden;
  box-sizing: border-box;
  .head {
    width: 100%;
    height: 100px;
    background: url(../../assets/xuhui/head-bg.png) no-repeat center center/100% 100%;
    position: relative;
    .title {
      text-align: center;
      font-size: 42px;
      color: #fff;
      padding-top: 32px;
    }
    .decoration {
      width: 16vw;
      height: 4vh;
      position: absolute;
      bottom: 0.7vh;
      &.left {
        left: 8vw;
      }
      &.right {
        right: 8vw;
      }
    }
  }
  .body {
    padding: 15px 26px 15px;
    box-sizing: border-box;
    display: flex;
    .left {
      width: 430px;
      height: 940px;
      // background: url(../../assets/xuhui/left.png) no-repeat center center;
      background: #082d58;
      box-shadow: 0px 4px 12px 0px rgba(0, 33, 70, 1);
      border-radius: 6px;
      background-size: 100% 100%;
    }
    .middle {
      width: 965px;
      margin: 0 20px;
      .top {
        width: 965px;
        height: 605px;
        // background: url(../../assets/xuhui/middle-t.png) no-repeat center center/100% 100%;
        background: #082d58;
        box-shadow: 0px 4px 12px 0px rgba(0, 33, 70, 1);
        border-radius: 6px;
      }
      .bottom {
        margin-top: 14px;
        width: 965px;
        height: 321px;
        // background: url(../../assets/xuhui/middle-b.png) no-repeat center center/100% 100%;
        background: #082d58;
        box-shadow: 0px 4px 12px 0px rgba(0, 33, 70, 1);
        border-radius: 6px;
      }
    }
    .right {
      width: 430px;
      height: 940px;
      background-size: 100% 100%;
      .middle {
        height: auto;
      }
    }
  }
  .box-title {
    font-size: 18px;
    color: #32c5ff;
    padding: 12px 24px;
    margin-left: 12px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .btn-area {
      display: flex;
      align-items: center;
      .btn {
        background: #31c1fb;
        border-radius: 4px;
        font-size: 14px;
        color: #082d58;
        padding: 5px 12px;
        cursor: pointer;
        & + .btn {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
